// A cell or form value counts as entered unless null, undefined or blank text.
const hasValue = (value) => value !== null && value !== undefined
  && !(typeof value === 'string' && value.trim() === '');

export default hasValue;
